var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CompassDialog", {
    staticClass: "backupCodesModal",
    attrs: {
      visible: _vm.showModal,
      size: "small",
      title: _vm.$t.__("popups.BackupCodes2FA.backup_codes")
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      },
      closed: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "dialog__default" },
              [
                _c(
                  "p",
                  { staticClass: "mb-2 typographies-paragraph-medium-regular" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$l10n.__(
                            "Ces codes vous permettent d'accéder à votre compte si vous n'avez temporairement pas accès à votre appareil ou que vous le perdez alors que la double authentification est active."
                          )
                        ) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "typographies-paragraph-medium-bold" },
                  [_vm._v(_vm._s(_vm.unusedBackupCodes))]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass:
                      "backupCodesModal__singleuse mb-2 typographies-paragraph-medium-regular"
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$l10n.__(
                            "Chaque code est à usage unique, vous pouvez en générer des nouveaux si vous les avez tous utilisés."
                          )
                        ) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("CompassPlainButton", {
                  attrs: {
                    label: _vm.$t.__(
                      "popups.BackupCodes2FA.generate_news_codes"
                    ),
                    leftIcon: "revert",
                    disabled: _vm.loading
                  },
                  on: { click: _vm.generateNewCodes }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "backupCodesModal__list" },
                  [
                    _vm.loading
                      ? _c("circular-loader", {
                          staticClass: "backupCodesModal__loader"
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { class: { "is-loading": _vm.loading } },
                      _vm._l(_vm.backupCodes, function(backupCode) {
                        return _c(
                          "li",
                          {
                            key: backupCode.id,
                            class: { "is-used": backupCode.used_at !== null }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(backupCode.code) +
                                "\n                    "
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "backupCodesModal__date" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$l10n.__("Codes générés le")) +
                      " " +
                      _vm._s(_vm.generationDate) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "backupCodesModal__actions" },
                  [
                    _c("CompassButton", {
                      attrs: {
                        label: _vm.$t.__("popups.BackupCodes2FA.print"),
                        type: "secondary",
                        disabled: _vm.loading
                      },
                      on: { click: _vm.handlePrint }
                    }),
                    _vm._v(" "),
                    _c("CompassButton", {
                      staticClass: "ml-3",
                      attrs: {
                        label: _vm.$t.__("popups.BackupCodes2FA.download_pdf"),
                        type: "secondary",
                        disabled: _vm.loading
                      },
                      on: { click: _vm.handleDownload }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "dialog__footer" },
              [
                _c("CompassButton", {
                  attrs: {
                    label: _vm.$t.__("common.actions.close"),
                    type: "primary",
                    disabled: _vm.loading
                  },
                  on: { click: _vm.close }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }